export default __webpack_public_path__ + "static/media/expert@3x.83b6bd30.png";